import React from 'react';
import styled from 'styled-components';

const StyledNavbarEnv = styled.div`
  background-color: #ffff66;
  position: fixed;
  top: 62px;
  z-index: 999;
  transform: translateY(-50%);
  height: 16px;
  width: 100%;
  text-align: center;
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
`;

const NavbarEnv = () => {
  if (
    process.env.REACT_APP_DEPLOY_ENV === 'COLLAUDO' ||
    process.env.REACT_APP_DEPLOY_ENV === 'FORMAZIONE'
  ) {
    return (
      <StyledNavbarEnv>
        AMBIENTE DI {process.env.REACT_APP_DEPLOY_ENV}
      </StyledNavbarEnv>
    );
  }

  return null;
};

export default NavbarEnv;
